import "./jplayer.scss"
require("jplayer/dist/jplayer/jquery.jplayer")
